import { EntityKeyByReference, Note } from '@card-software/library';
import { OutgoingReceiptLineBase } from '../receipt-line-base';
import { AuditTrail } from '@card-software/nexus-models';
import { Translation } from '../translation';
import { StatusHistoryEntry } from './goods-receipt';

export enum ProviderReturnStatus {
  Pending = 0,
  Processing = 1,
  Completed = 2,
  Cancelled = 3,
  Rejected = 4,
}

export interface ProviderReturnLine extends OutgoingReceiptLineBase {
  lineReturnReason?: string;
}

export interface ProviderReturn extends AuditTrail {
  /** Descends from an Administrative purchase order (#5942); only role holders can see it, the API enforces. */
  isAdministrative?: boolean;
  id?: string;
  number?: string;
  initiator: EntityKeyByReference;
  status: ProviderReturnStatus;
  locationCode: string;
  locationName?: Translation;
  goodsReceiptNumber?: string;
  returnDate: Date;
  returnReason: string;
  entries: ProviderReturnLine[];
  trackingNumber?: string;
  expectedReturnDate?: Date;
  notes?: Note[];
  statusHistory?: StatusHistoryEntry<ProviderReturnStatus>[];
}
